import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { AnalyticsService } from 'src/app/service/analytics/analytics.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Libreria Virtual';
  private debuggerInterval: any;

  constructor(
    public utilitarioService: UtilitarioService,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit(): void {
    this.analyticsService.init();
    this.activarProteccion();
  }

  ngAfterViewInit() {
    this.utilitarioService.loading = false;
  }

  ngOnDestroy(): void {
    if (this.debuggerInterval) {
      clearInterval(this.debuggerInterval);
    }
  }

  /** Bloquear clic derecho */
  @HostListener('document:contextmenu', ['$event'])
  onRightClick(event: Event): void {
    event.preventDefault();
  }

  /** Bloquear teclas de inspección: F12, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+U */
  @HostListener('document:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    // F12
    if (event.key === 'F12') {
      event.preventDefault();
      return;
    }
    // Ctrl+Shift+I (Inspector)
    if (event.ctrlKey && event.shiftKey && event.key === 'I') {
      event.preventDefault();
      return;
    }
    // Ctrl+Shift+J (Consola)
    if (event.ctrlKey && event.shiftKey && event.key === 'J') {
      event.preventDefault();
      return;
    }
    // Ctrl+U (Ver código fuente)
    if (event.ctrlKey && event.key === 'u') {
      event.preventDefault();
      return;
    }
    // Ctrl+Shift+C (Selector de elementos)
    if (event.ctrlKey && event.shiftKey && event.key === 'C') {
      event.preventDefault();
      return;
    }
  }

  /** Activar debugger infinito y deshabilitar arrastrar imágenes */
  private activarProteccion(): void {
    // Debugger infinito - si abren DevTools se queda pausado
    this.debuggerInterval = setInterval(() => {
      (function () {
        return false;
      })
        ['constructor']('debugger')
        ['call']();
    }, 50);

    // Deshabilitar arrastrar imágenes
    document.addEventListener('dragstart', (e: DragEvent) => {
      if (e.target && (e.target as HTMLElement).tagName === 'IMG') {
        e.preventDefault();
      }
    });
  }
}
